import React, { useEffect, useRef, useState } from 'react';
import { Button } from '@/shared/ui/button';
import BaseDealDetailDialog from '@/modules/deals/shared/components/BaseDealDetailDialog';
import { IconActionButton } from '@/shared/components/patterns';

const InProgressDetailDialog = ({
  deal,
  isOpen,
  onClose,
  focusComments = false,
  onSave,
  onComplete,
  onCancel,
  onReturnToProposal,
  completionState = {},
  onOpenClient,
  onOpenStaff,
  staff,
  clients,
  canManageDealDestructiveActions = false,
}) => {
  const [completionPaymentStatus, setCompletionPaymentStatus] = useState('');
  const [completionMode, setCompletionMode] = useState(false);
  const statusRef = useRef(null);
  useEffect(() => { if (completionMode) { statusRef.current?.scrollIntoView?.({ block: 'nearest' }); statusRef.current?.focus(); } }, [completionMode]);

  useEffect(() => {
    setCompletionPaymentStatus('');
    setCompletionMode(false);
  }, [deal?.id, isOpen]);

  const canComplete = Boolean(deal && !deal.completedDealId && !deal.cancelledAt && !deal.revertedAt);
  const canReturnToProposal = Boolean(canComplete && deal.sourceProposalId);

  return (
    <BaseDealDetailDialog focusComments={focusComments}
      deal={deal}
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      onOpenClient={onOpenClient}
      onOpenStaff={onOpenStaff}
      dealType="inCorso"
      staff={staff}
      clients={clients}
      allowEditing={!completionState.loading}
      allowTypeChange={false}
      primaryActions={
        canComplete ? (
          completionMode ? (
            <>
              <Button
                type="button"
                disabled={!completionPaymentStatus || completionState.loading}
                onClick={() => onComplete?.(deal.id, completionPaymentStatus)}
              >
                {completionState.loading ? 'Completamento…' : 'Conferma completamento'}
              </Button>
              <Button
                type="button"
                variant="outline"
                disabled={completionState.loading}
                onClick={() => {
                  setCompletionMode(false);
                  setCompletionPaymentStatus('');
                }}
              >
                Annulla
              </Button>
            </>
          ) : (
            <IconActionButton
              iconKey="status.completed"
              tone="success"
              label="Completa affare"
              disabled={completionState.loading}
              onClick={() => setCompletionMode(true)}
            />
          )
        ) : null
      }
      dangerActions={
        canComplete && canManageDealDestructiveActions ? (
          <IconActionButton
            iconKey="actions.delete"
            label="Annulla affare"
            tone="danger"
            disabled={completionState.loading}
            onClick={() => onCancel?.(deal.id)}
          />
        ) : null
      }
      ordinaryActions={
        canReturnToProposal && canManageDealDestructiveActions ? (
          <IconActionButton
            iconKey="actions.reset"
            label="Riporta nelle proposte"
            disabled={completionState.loading}
            onClick={() => onReturnToProposal?.(deal.id)}
          />
        ) : null
      }
      workflowContent={
        canComplete && completionMode ? (
          <div className="deal-detail__workflow-panel">
            <div className="min-w-[220px]">
              <label className="text-xs text-[var(--text-secondary)]" htmlFor={`settlement-${deal.id}`}>
                Stato incasso
              </label>
              <select ref={statusRef} id={`settlement-${deal.id}`} className="mt-1 w-full"
                value={completionPaymentStatus} disabled={completionState.loading}
                onChange={(event) => setCompletionPaymentStatus(event.target.value)}>
                <option value="">Seleziona lo stato dell’incasso</option>
                <option value="da_saldare">Da incassare</option>
                <option value="saldato">Già incassato</option>
              </select>
            </div>
            {completionState.error ? (
              <p className="deal-detail__error wt-inline-error" role="alert">{completionState.error}</p>
            ) : null}
          </div>
        ) : null
      }
    />
  );
};

export default InProgressDetailDialog;
